import KEY_EXPORT_CLASSROOM_REPORT_QUERY from 'graph/reports/key-export-classroom-report-query';
import getClassroomPrimaryEducator from 'utilities/get-classroom-primary-eduator';
import { STUDENT_WORKSHEETS } from './student';
import { KeyOrganizationClassroomEngagementReportResult } from 'types/schema-generated-types';
import {
  ReportWorkbook,
  KeyClassroomExportingDaata,
  ReportEntityType
} from 'components/ReportsModule/types';

export const CLASSROOM_WORKBOOK: ReportWorkbook<KeyClassroomExportingDaata> = {
  query: KEY_EXPORT_CLASSROOM_REPORT_QUERY,
  getEntityName: (data): string => data.classroom?.classroom?.name ?? '',
  worksheets: [
    {
      name: ReportEntityType.CLASSROOM,
      parseQueryData: (data): any[][] => [data.classroom].map(mapClassroomWorksheet)
    },
    ...STUDENT_WORKSHEETS
  ]
};

export const mapClassroomWorksheet = (
  data: KeyOrganizationClassroomEngagementReportResult
): any => {
  const educator = data.classroom && getClassroomPrimaryEducator(data.classroom);
  return {
    classroomName: data.classroom?.name,
    classroomSisId: data.classroom?.sisId,
    educator: educator && `${educator.firstName} ${educator.lastName}`,
    educatorSisId: educator && educator.sisId,
    organization: data.classroom?.organization?.name,
    studentCount: data.totalStudentCount,
    activeStudents: data.activeStudentCount,
    assignedLicenses: data.classroom?.licenseUsage
      ?.map(usage => usage.assignedCount)
      .reduce((a, b) => a + b, 0),
    overallCurriculumProgress: data.curriculumProgressPercentage,
    activitiesCompletedTotal: data.totalActivitiesCompletedCount,
    averageWeeklyTimeSpentTotal: data.averageWeeklyMinutesSpent
  };
};
